// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../routes/paths'
// components
import SvgIconStyle from '../../components/SvgIconStyle'
import { Stack } from '@material-ui/core'

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: '100%', height: '100%' }}
  />
)

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  kanban: getIcon('ic_kanban'),
}

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'production control board',
        path: PATH_DASHBOARD.general.app,
        icon: <Stack className="oui--dashboard" />,
        hidden: (user) =>
          user?.user_type !== 2 &&
          !(
            user?.permission_id &&
            (user.permission_id.includes('124') ||
              user.permission_id.includes('125') ||
              user.permission_id.includes('126') ||
              user.permission_id.includes('127') ||
              user.permission_id.includes('128') ||
              user.permission_id.includes('129') ||
              user.permission_id.includes('130') ||
              user.permission_id.includes('131') ||
              user.permission_id.includes('132') ||
              user.permission_id.includes('133') ||
              user.permission_id.includes('134') ||
              user.permission_id.includes('135') ||
              user.permission_id.includes('136') ||
              user.permission_id.includes('137') ||
              user.permission_id.includes('138') ||
              user.permission_id.includes('139') ||
              user.permission_id.includes('140') ||
              user.permission_id.includes('141') ||
              user.permission_id.includes('142') ||
              user.permission_id.includes('143'))
          ),
      },
      // { title: 'bookings', path: PATH_DASHBOARD.general.quotation, icon: <Stack className='lucide--package-check' /> },
      {
        title: 'bookings',
        path: PATH_DASHBOARD.general.bookings,
        icon: <Stack className="lucide--package-check" />,
        hidden: (user) =>
          user?.user_type !== 2 &&
          !(
            user?.permission_id &&
            (user.permission_id.includes('50') ||
              user.permission_id.includes('51') ||
              user.permission_id.includes('52') ||
              user.permission_id.includes('53') ||
              user.permission_id.includes('54') ||
              user.permission_id.includes('55') ||
              user.permission_id.includes('56') ||
              user.permission_id.includes('57') ||
              user.permission_id.includes('58') ||
              user.permission_id.includes('59') ||
              user?.permission_id.includes('146'))
          ),
      },
      {
        title: 'godown destinations',
        path: PATH_DASHBOARD.general.godown_destinations,
        icon: <Stack className="mdi--warehouse" />,
        hidden: (user) => user?.user_type !== 1, // Restricted to Admin
      },
      // { title: 'quotations', path: PATH_DASHBOARD.general.quotation, icon: <Stack className='mi--document' /> },
      {
        title: 'users',
        path: PATH_DASHBOARD.general.users,
        icon: <Stack className="mdi--users-outline" />,
        hidden: (user) =>
          user.user_type === 2 &&
          !(
            user?.permission_id?.split(',').includes('1') ||
            user?.permission_id?.split(',').includes('2') ||
            user?.permission_id?.split(',').includes('3') ||
            user?.permission_id?.split(',').includes('4') ||
            user?.permission_id?.split(',').includes('5') ||
            user?.permission_id?.split(',').includes('6') ||
            user?.permission_id?.split(',').includes('7')
          ),
      },
      {
        title: 'customers',
        path: PATH_DASHBOARD.general.customers,
        icon: <Stack className="mdi--users-group-outline" />,
        hidden: (user) =>
          user.user_type === 2 &&
          !(
            user?.permission_id?.split(',').includes('42') ||
            user?.permission_id?.split(',').includes('43') ||
            user?.permission_id?.split(',').includes('44') ||
            user?.permission_id?.split(',').includes('45') ||
            user?.permission_id?.split(',').includes('46') ||
            user?.permission_id?.split(',').includes('47') ||
            user?.permission_id?.split(',').includes('48') ||
            user?.permission_id?.split(',').includes('49')
          ),
      },
      {
  title: 'receivers',
  path: PATH_DASHBOARD.general.receivers,
  icon: <Stack className="mdi--users-group-outline" />,
  hidden: (user) =>
    !(
      (user?.user_type === 1 || user?.user_type === 2 || user?.user_type === 5) &&
      (
        user?.permission_id?.split(',').includes('116') ||
        user?.permission_id?.split(',').includes('117') ||
        user?.permission_id?.split(',').includes('118') ||
        user?.permission_id?.split(',').includes('119') ||
        user?.permission_id?.split(',').includes('120') ||
        user?.permission_id?.split(',').includes('121') ||
        user?.permission_id?.split(',').includes('122') ||
        user?.permission_id?.split(',').includes('123')
      )
    )
},

      {
        title: 'vehicles',
        path: PATH_DASHBOARD.general.vehicles.root,
        icon: <Stack className="tdesign--vehicle" />,
        hidden: (user) =>
          user.user_type === 2 &&
          !(
            user?.permission_id?.split(',').includes('16') ||
            user?.permission_id?.split(',').includes('17') ||
            user?.permission_id?.split(',').includes('18') ||
            user?.permission_id?.split(',').includes('19') ||
            user?.permission_id?.split(',').includes('20') ||
            user?.permission_id?.split(',').includes('21') ||
            user?.permission_id?.split(',').includes('22') ||
            user?.permission_id?.split(',').includes('27') ||
            user?.permission_id?.split(',').includes('28') ||
            user?.permission_id?.split(',').includes('29') ||
            user?.permission_id?.split(',').includes('30') ||
            user?.permission_id?.split(',').includes('31') ||
            user?.permission_id?.split(',').includes('32') ||
            user?.permission_id?.split(',').includes('33')
          ),
        children: [
          {
            title: 'vehicles',
            path: PATH_DASHBOARD.general.vehicles.vehicle,
            hidden: (user) =>
              !(
                user?.permission_id &&
                (user?.permission_id?.split(',').includes('27') ||
                  user?.permission_id?.split(',').includes('28') ||
                  user?.permission_id?.split(',').includes('29') ||
                  user?.permission_id?.split(',').includes('30') ||
                  user?.permission_id?.split(',').includes('31') ||
                  user?.permission_id?.split(',').includes('32') ||
                  user?.permission_id?.split(',').includes('33') ||
                  user?.permission_id?.split(',').includes('60'))
              ),
            icon: <Stack className="material-symbols--delivery-truck-speed" />,
          },
          {
            title: 'drivers',
            path: PATH_DASHBOARD.general.vehicles.driver,
            hidden: (user) =>
              !(
                user?.permission_id &&
                (user?.permission_id?.split(',').includes('16') ||
                  user?.permission_id?.split(',').includes('17') ||
                  user?.permission_id?.split(',').includes('18') ||
                  user?.permission_id?.split(',').includes('19') ||
                  user?.permission_id?.split(',').includes('20') ||
                  user?.permission_id?.split(',').includes('21') ||
                  user?.permission_id?.split(',').includes('22'))
              ),
            icon: <Stack className="healthicons--truck-driver" />,
          },
        ],
      },

      {
        title: 'trips',
        path: PATH_DASHBOARD.general.trips,
        icon: <Stack className="bx--trip" />,
        hidden: (user) =>
          user.user_type === 2 &&
          !(
            user?.permission_id?.split(',').includes('34') ||
            user?.permission_id?.split(',').includes('35') ||
            user?.permission_id?.split(',').includes('36') ||
            user?.permission_id?.split(',').includes('37') ||
            user?.permission_id?.split(',').includes('38') ||
            user?.permission_id?.split(',').includes('39') ||
            user?.permission_id?.split(',').includes('40') ||
            user?.permission_id?.split(',').includes('41')
          ),
      },
      {
        title: 'Vehicles',
        path: PATH_DASHBOARD.general.driver_vehicle,
        icon: <Stack className="bx--trip" />,
        hidden: (user) =>
          user.user_type !== 3
          
      },
      {
        title: 'branches',
        path: PATH_DASHBOARD.general.branches,
        icon: <Stack className="mdi--building" />,
        hidden: (user) =>
          user.user_type === 2 &&
          !(
            user?.permission_id?.split(',').includes('8') ||
            user?.permission_id?.split(',').includes('9') ||
            user?.permission_id?.split(',').includes('10') ||
            user?.permission_id?.split(',').includes('11') ||
            user?.permission_id?.split(',').includes('12') ||
            user?.permission_id?.split(',').includes('13') ||
            user?.permission_id?.split(',').includes('14') ||
            user?.permission_id?.split(',').includes('15')
          ),
      },
      {
        title: 'roles',
        path: PATH_DASHBOARD.general.roles,
        icon: <Stack className="ix--roles" />,
        hidden: (user) =>
          user.user_type === 2 &&
          !(
            user?.permission_id?.split(',').includes('23') ||
            user?.permission_id?.split(',').includes('24') ||
            user?.permission_id?.split(',').includes('25') ||
            user?.permission_id?.split(',').includes('26')
          ),
      },
      {
        title: 'reports',
        path: PATH_DASHBOARD.general.reports.root,
        icon: <Stack className="mingcute--documents-fill" />,
        hidden: (user) =>
          user.user_type !== 2 &&
          !(
            user?.permission_id?.split(',').includes('61') ||
            user?.permission_id?.split(',').includes('63') ||
            user?.permission_id?.split(',').includes('63') ||
            user?.permission_id?.split(',').includes('64') ||
            user?.permission_id?.split(',').includes('65') ||
            user?.permission_id?.split(',').includes('66') ||
            user?.permission_id?.split(',').includes('67') ||
            user?.permission_id?.split(',').includes('68') ||
            user?.permission_id?.split(',').includes('69') ||
            user?.permission_id?.split(',').includes('85') ||
            user?.permission_id?.split(',').includes('86') ||
            user?.permission_id?.split(',').includes('87') ||
            user?.permission_id?.split(',').includes('88') ||
            user?.permission_id?.split(',').includes('89') ||
            user?.permission_id?.split(',').includes('90') ||
            user?.permission_id?.split(',').includes('91') ||
            user?.permission_id?.split(',').includes('92') ||
            user?.permission_id?.split(',').includes('93') ||
            user?.permission_id?.split(',').includes('94') ||
            user?.permission_id?.split(',').includes('95') ||
            user?.permission_id?.split(',').includes('96') ||
            user?.permission_id?.split(',').includes('97') ||
            user?.permission_id?.split(',').includes('98') ||
            user?.permission_id?.split(',').includes('99') ||
            user?.permission_id?.split(',').includes('100')
          ),
        children: [
          {
            title: 'booking statement reports',
            path: PATH_DASHBOARD.general.reports.bookingStatementReports,
            hidden: (user) =>
              !(
                user?.permission_id &&
                user?.permission_id?.split(',').includes('61') ||
                user?.permission_id?.split(',').includes('63') ||
                user?.permission_id?.split(',').includes('63') ||
                user?.permission_id?.split(',').includes('64')
              ),
            icon: <Stack className="line-md--file-document-twotone" />,
          },
          {
            title: 'booking reports',
            path: PATH_DASHBOARD.general.reports.bookingReports,
            hidden: (user) =>
              !(
                user?.permission_id &&
                user?.permission_id?.split(',').includes('65') ||
                user?.permission_id?.split(',').includes('66') ||
                user?.permission_id?.split(',').includes('67') ||
                user?.permission_id?.split(',').includes('68')
              ),
            icon: <Stack className="ion--document-text" />,
          },
          {
            title: 'booking summary reports',
            path: PATH_DASHBOARD.general.reports.bookingSummaryReports,
            hidden: (user) =>
              !(
                user?.permission_id &&
                user?.permission_id?.split(',').includes('69') ||
                user?.permission_id?.split(',').includes('85') ||
                user?.permission_id?.split(',').includes('86') ||
                user?.permission_id?.split(',').includes('87')
              ),
            icon: <Stack className="fluent--document-data-20-filled" />,
          },
          // { title: 'delivery statement reports', path: PATH_DASHBOARD.general.reports.deliveryStatementReports, hidden: (user) => user.user_type === 2 },
          {
            title: 'delivery reports',
            path: PATH_DASHBOARD.general.reports.deliveryReports,
            hidden: (user) =>
              !(
                user?.permission_id &&
                user?.permission_id?.split(',').includes('88') ||
                user?.permission_id?.split(',').includes('89') ||
                user?.permission_id?.split(',').includes('90') ||
                user?.permission_id?.split(',').includes('91')
              ),
            icon: <Stack className="ci--file-document" />,
          },
          {
            title: 'delivery summary reports',
            path: PATH_DASHBOARD.general.reports.deliverySummaryReports,
            hidden: (user) =>
              !(
                user?.permission_id &&
                user?.permission_id?.split(',').includes('92') ||
                user?.permission_id?.split(',').includes('93') ||
                user?.permission_id?.split(',').includes('94') ||
                user?.permission_id?.split(',').includes('95')
              ),
            icon: <Stack className="fluent--document-text-32-regular" />,
          },
          {
            title: 'cancelled reports',
            path: PATH_DASHBOARD.general.reports.cancelledReports,
            hidden: (user) =>
              !(
                user?.permission_id &&
                user?.permission_id?.split(',').includes('96') ||
                user?.permission_id?.split(',').includes('97') ||
                user?.permission_id?.split(',').includes('98') ||
                user?.permission_id?.split(',').includes('99') ||
                user?.permission_id?.split(',').includes('100')
              ),
            icon: <Stack className="line-md--document-report-twotone" />,
          },
        ],
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     // MANAGEMENT : USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.newUser },
  //         { title: 'edit', path: PATH_DASHBOARD.user.editById },
  //         { title: 'account', path: PATH_DASHBOARD.user.account }
  //       ]
  //     },

  //     // MANAGEMENT : E-COMMERCE
  //     {
  //       title: 'e-commerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.productById },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.newProduct },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.editById },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //         { title: 'invoice', path: PATH_DASHBOARD.eCommerce.invoice }
  //       ]
  //     },

  //     // MANAGEMENT : BLOG
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         { title: 'post', path: PATH_DASHBOARD.blog.postById },
  //         { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
  //       ]
  //     }
  //   ]
  // },

  // // APP
  // // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     { title: 'mail', path: PATH_DASHBOARD.mail.root, icon: ICONS.mail },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban }
  //   ]
  // }
]

export default sidebarConfig
